<nz-modal
  [nzVisible]="visible()"
  nzTitle="Lodge a Ticket"
  [nzWidth]="440"
  [nzFooter]="footer"
  (nzOnCancel)="close()"
>
  <ng-container *nzModalContent>
    <p class="mb-4 text-sm text-gray-600">Describe the issue you want to report.</p>

    <nz-alert
      class="mb-4 block"
      nzType="warning"
      nzMessage="Tell us what happened so we can investigate properly. You can also try the action again before reporting it."
    ></nz-alert>

    <label for="lodge-ticket-description" class="mb-2 block text-sm font-medium text-gray-700">
      Describe the issue
    </label>
    <nz-textarea-count [nzMaxCharacterCount]="maxLength">
      <textarea
        id="lodge-ticket-description"
        nz-input
        nzSize="large"
        rows="4"
        [maxlength]="maxLength"
        [formControl]="description"
        placeholder="What were you trying to do, and what went wrong?"
      ></textarea>
    </nz-textarea-count>
  </ng-container>
</nz-modal>

<ng-template #footer>
  <button
    nz-button
    nzType="primary"
    nzSize="large"
    type="button"
    [nzLoading]="isSubmitting()"
    [disabled]="description.invalid || !description.value.trim()"
    (click)="submit()"
  >
    Report Issue
  </button>
</ng-template>
